<template>
    <v-container
        fluid
        class="mt-0 pt-0"
    >
        <v-card outlined>
            <v-form 
                ref="form" 
                v-model="valid" 
                :lazy-validation="lazy"
            >
                <v-card-title>Datos del proyecto</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                            cols="12"
                            md="8"
                        >
                            <v-text-field
                                v-model="nombreProyecto"
                                label="Nombre del proyecto *"
                                :loading="loading || loadingProp"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                required
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('datosProyecto', 'nombreProyecto', nombreProyecto)"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                        >
                            <select-tipo-proyecto
                                :id-tipo-proyecto-prop="obj.idTipoProyecto"
                                :fn-change="fnChangeTipoProyecto"
                                :requerido="true"
                                :edit="idAccion == 1 || idAccion == 2"
                                :loading-prop="loading || loadingProp"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col
                            cols="12"
                            class="text-center"
                        >
                            <label style="color:rgba(0, 0, 0, 0.6);">
                                ¿Es un proyecto financiado? *
                            </label>
                            <div class="flex-center">
                                <v-radio-group
                                    v-model="proyectoFinanciado"
                                    row
                                    class="justify-center"
                                    required
                                    :rules="[(v) => v != null || 'Campo obligatorio']"
                                    :readonly="!(idAccion == 1 || idAccion == 2)"
                                    @change="fnSetValue('datosProyecto', 'proyectoFinanciado', proyectoFinanciado)"
                                >
                                    <v-layout>
                                        <v-flex>
                                            <v-radio :value="true">
                                                <template v-slot:label>
                                                    <div>Si</div>
                                                </template>
                                            </v-radio>
                                        </v-flex>

                                        <v-flex>
                                            <v-radio :value="false">
                                                <template v-slot:label>
                                                    <div>No</div>
                                                </template>
                                            </v-radio>
                                        </v-flex>
                                    </v-layout>
                                </v-radio-group>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row v-if="proyectoFinanciado == true">
                        <v-col
                            cols="12"
                            md="6"
                        >
                            <v-text-field
                                v-model="anioFormalizacion"
                                type="number"
                                label="Año de formalización *"
                                min="1900"
                                max="2050"
                                :loading="loading || loadingProp"
                                :rules="reglasAnio"
                                required
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('datosProyecto', 'anioFormalizacion', anioFormalizacion)"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                        >
                            <v-text-field
                                v-model="numAsignado"
                                :loading="loading || loadingProp"
                                label="Folio o número de asignación o identificación del proyecto por parte del organismo financiador *"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                required
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('datosProyecto', 'numAsignado', numAsignado)"
                            />
                        </v-col>
                    </v-row>
                    <!--  <v-row v-if="proyectoFinanciado == true">
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="convocatoria"
                                :loading="loading || loadingProp"
                                label="Convocatoria *"
                                :rules="[(v) => !!v || 'Campo obligatorio']"
                                required
                                :readonly="!(idAccion == 1 || idAccion == 2)"
                                @change="fnSetValue('datosProyecto', 'convocatoria', convocatoria)"
                            />
                            <!--    <select-convocatoria
                                :id-convocatoria-prop="obj.idConvocatoria"
                                :fn-change="fnChangeConvocatoria"
                                :requerido="true"
                                :loading-prop="loading || loadingProp"
                                :edit="false"
                            /> 
                        </v-col>
                    </v-row> -->
                    <v-row v-if="proyectoFinanciado == true">
                        <v-col cols="12">
                            <form-financiamiento
                                :lst-financiamiento-prop="obj.lstFinanciamiento"
                                :fn-set-value="fnSetValue"
                                :edit="idAccion == 1 || idAccion == 2"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <card-archivo-solicitud
                                :id-proyecto="idProyecto"
                                :id-accion="idAccion"
                                :nombre-dirigido="obj.nombrePresidente"
                                :file-solicitud="obj.fileSolicitud"
                                :file-id="obj.fileSolicitudId"
                                :file-name="obj.fileSolicitudName"
                                :file-uuid="obj.fileSolicitudUuid"                                
                                :edit="idAccion == 1 || idAccion == 2"
                                :fn-change="fnChangeFileSolicitud"
                                :show-validation-error="showValidationError"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>

            <v-card-actions v-if="idAccion == 1 || idAccion == 2">
                <v-spacer />
                <v-btn
                    color="blue" 
                    rounded 
                    dark
                    @click="setSectionProp({ nombre: 'Generales del proyecto', id: 'generales-del-proyecto' }, true); $refs.form.validate();"
                >
                    Siguiente
                    <v-icon right>
                        mdi-arrow-right
                    </v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>



        <v-snackbar
            key="snackbarFormDatosProyecto"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false;"
            >
                Cerrar
            </v-btn>
        </v-snackbar> 
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "FormDatosProyecto",
  components: {
    FormFinanciamiento: () => import("../formDatosProyecto/FormFinanciamiento"),
    CardArchivoSolicitud: () => import("../../compartidos/CardArchivoSolicitud"),
    // SelectConvocatoria: () => import("../../compartidos/SelectConvocatoria"),
    SelectTipoProyecto: () => import("../../compartidos/SelectTipoProyecto"),
  },
  props: {
    idProyecto: {
      type: Number,
      required: true
    },
    idAccion: {
      type: Number,
      required: true,
    },
    obj: {
        type: Object,
        required: true
    },
    loadingProp: {
        type: Boolean,
        default: false
    },
    fnSetValue: {
        type: Function,
        default: () => 1,
    },
    banValidarForm: {
        type: Number,
        default: 0
    },
    updateValidForms: {
        type: Function,
        default: () => 1,
    },
    setSectionProp: {
        type: Function,
        default: () => 1,
    }
  },
  data () {
    return {
        nombreProyecto: '',
        idTipoProyecto: null,
        proyectoFinanciado: null,
        anioFormalizacion: '',
        numAsignado: '',
        idConvocatoria: null,
        convocatoria: null,
        fileSolicitud: null,
        fileSolicitudUuid: '',
        showValidationError: false,

        loading: false,
        snackbar: false,
        snackbarColor: '',
        snackbarTexto: '',  
        
        valid: false,
        lazy: false,

        reglasAnio: [ 
            v => !!v || "Campo obligatorio",
            v => ( v && v >= 1900 ) || "El año debe ser mayor a 1900",
            v => ( v && v <= 2050 ) || "El año debe ser menor a 2050",
        ],
    };
  },
  computed: {
      ...mapGetters("oidc", ["oidcUser"]),
      porcentajeCapturado: function () {
        if(this.obj.lstFinanciamiento.length == 0) {
            return 0;
        }
        else{
            return this.obj.lstFinanciamiento.map((item) => item.porcentaje).reduce((prev, curr) => prev + curr, 0).toFixed(2);
        }
      },
      fileSolicitudName () {
        return this.obj.fileSolicitudName;
      },
      fileSolicitudd () {
        return this.obj.fileSolicitud;
      }

   },
  watch: {
    banValidarForm: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    },
    valid: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    }, 
    fileSolicitudd: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    }, 
    fileSolicitudName: {
        handler (newValue, oldValue) {
            this.fnValidarFormulario();
        },
    }, 

/*     obj: {
        handler (newValue, oldValue) {
            var valido = this.valid  && (this.proyectoFinanciado ? (parseInt(this.porcentajeCapturado) == 100) : true) && ((newValue.fileSolicitud != null && newValue.fileSolicitud != undefined) || (newValue.fileSolicitudName != '' && newValue.fileSolicitudName != null))
            this.updateValidForms(1, valido);
        },
        deep: true,
        immediate: true 
    }, */
  },
  async mounted () {
      this.fnSetValuesProp();
  },
  methods: {
      fnValidarFormulario () {
          this.showValidationError = true;
          if (this.valid && (this.proyectoFinanciado ? (parseInt(this.porcentajeCapturado) == 100) : true) && ((this.obj.fileSolicitud != null && this.obj.fileSolicitud != undefined) || (this.obj.fileSolicitudName != '' && this.obj.fileSolicitudName != null))) {
              this.updateValidForms(1, true);
          }
          else{
              this.updateValidForms(1, false);
          }
      },
      fnSetValuesProp () {
          this.loading = true;
          this.nombreProyecto = this.obj.nombreProyecto == null ? '' : this.obj.nombreProyecto;
          this.proyectoFinanciado = this.obj.proyectoFinanciado;
          this.anioFormalizacion = this.obj.anioFormalizacion;
          this.numAsignado = this.obj.numAsignado == null ? '' : this.obj.numAsignado;
          this.idConvocatoria = this.obj.idConvocatoria;
          this.convocatoria = this.obj.convocatoria;

          this.fileSolicitud = this.obj.fileSolicitud;
          this.fileSolicitudUuid = this.obj.fileSolicitudUuid;

          this.$refs.form.resetValidation()

          this.loading = false;
          this.fnValidarFormulario();
      },
      fnChangeTipoProyecto (objTipoProyecto) {
          this.fnSetValue('datosProyecto', "idTipoProyecto", objTipoProyecto.idTipoProyectoPk)
      },
      fnChangeConvocatoria (objConv) {
          this.fnSetValue('datosProyecto', "idConvocatoria", objConv.idConvocatoriaPk)
      },
      fnChangeFileSolicitud (file) {
            this.fnSetValue('datosProyecto', "fileSolicitud", file)
            if(file == null) {
                this.fnSetValue('datosProyecto', "fileSolicitudUuid", '')
                this.fnSetValue('datosProyecto', "fileSolicitudId", '')
                this.fnSetValue('datosProyecto', "fileSolicitudName", '')
            }
      },
  }
};
</script>

<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
</style>